import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { DetailDrawer } from '@/components/Work/Unified/DetailDrawer'
import type { Record_ } from '@/components/Work/Unified/types'
import { MarginTargetsSection } from '@/components/Settings/team/MarginTargetsSection'
import { LaborRatesSection } from '@/components/Settings/team/LaborRatesSection'
import MarginReport from '@/pages/MarginReport'
import { CostingFixtureContext } from './fixturePermissions'

const job: Record_ = {
  id: 'job:__design-job-costing', jobId: '__design-job-costing', customer: '[DEMO] Costing customer',
  address: '', stage: 'SCHEDULED', total: 4800, service: null, serviceCategoryId: null, serviceSlug: null, serviceColor: null,
}

/** A separate route tree: no live Work queries, account settings or providers. */
export function CostingDemo() {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(true)
  return <CostingFixtureContext.Provider value><main className="page-container animate-fade-up">
    <p role="status">Demo — changes are temporary and never saved to your workspace.</p>
    <nav aria-label="Costing demo" className="flex flex-wrap gap-4">
      <Link to="/work?__design=job-costing" onClick={() => setOpen(true)}>Demo job</Link>
      <Link to="/settings/team?__design=job-costing">Demo rates and targets</Link>
      <Link to="/reports/margin?__design=job-costing">Demo margins</Link>
      <Link to="/work">Exit demo</Link>
    </nav>
    {pathname === '/settings/team' ? <><LaborRatesSection /><MarginTargetsSection /></>
      : pathname === '/reports/margin' ? <MarginReport />
      : <>
        <button onClick={() => setOpen(true)}>Open demo job</button>
        <DetailDrawer record={open ? job : null} onClose={() => setOpen(false)} onAdvance={() => {}} costingFixture />
      </>}
  </main></CostingFixtureContext.Provider>
}
